<template>
	<div
		class="svg-icon"
		:class="[flexClass, attrs.class]">
		<nuxt-icon
			:filled="true"
			v-bind="iconAttrs"
			:name="name" />
	</div>
</template>
<script setup lang="ts">
defineOptions({ inheritAttrs: false })

const props = defineProps<{
	height?: number | string
	width?: number | string
	name: string
	color?: string
	default?: boolean
	flex?: boolean
}>()

const attrs = useAttrs()

const iconAttrs = computed(() => {
	const rest = { ...attrs } as Record<string, unknown>
	delete rest.class
	return rest
})

const iconColorCss = computed(() => props.color ?? 'currentColor')

const heightPx = computed(() => {
	if (props.height === undefined || props.height === null) return '1em'
	return props.height === 'fit-content' ? props.height : `${props.height}px`
})

const widthPx = computed(() => {
	if (props.width !== undefined && props.width !== null) {
		return typeof props.width === 'string' ? props.width : `${props.width}px`
	}
	if (props.height !== undefined && props.height !== null && props.height !== 'fit-content') {
		return `${props.height}px`
	}
	return '1em'
})

const verticalAlign = computed(() => (props.default ? 'unset' : 'middle'))
const marginBottom = computed(() => (props.default ? '0px' : '0.125em'))

const flexClass = computed(() => (props.flex ? 'flex' : ''))
</script>
<style lang="scss">
.svg-icon {
	width: v-bind(widthPx);
	min-width: v-bind(widthPx);
	height: v-bind(heightPx);
	color: v-bind(iconColorCss);
	font-size: v-bind(heightPx);

	&.flex {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.nuxt-icon svg {
		height: 100%;
		width: 100%;
		vertical-align: v-bind(verticalAlign);
		margin-bottom: v-bind(marginBottom);
	}
}
</style>
